import { ActionChip, Tags } from "@risalabs_frontend_org/oasis-ui-kit";
import { ThumbsDownIcon } from "../../../svg/thumbs-down-icon";
import { ThumbsUpIcon } from "../../../svg/thumbs-up-icon";
import {
  APPROVAL_INVALID_BG,
  APPROVAL_INVALID_TEXT,
  APPROVAL_VALID_BG,
  APPROVAL_VALID_TEXT,
  APPROVE_LABEL,
  INVALID_BADGE_LABEL,
  REJECT_LABEL,
  VALID_BADGE_LABEL,
  type ApprovalStatus,
} from "../utils/constants";

export interface SectionApprovalActionsProps {
  approvalStatus: ApprovalStatus;
  onApprovalStatusChange: (status: ApprovalStatus) => void;
  /** Chip size; omit for default. */
  size?: "small" | "medium";
  /** When true, render the status Tags badge. Default true. */
  showBadge?: boolean;
  /** Override label for "invalid" badge (e.g. FEEDBACK_MODE_BADGE_LABEL). Default INVALID_BADGE_LABEL. */
  invalidBadgeLabel?: string;
  /** Render only chips, only badge, or both. Default "both". Use "chips"/"badge" when passing to DetailCard actions/badge. */
  variant?: "chips" | "badge" | "both";
}

const SectionApprovalActions = ({
  approvalStatus,
  onApprovalStatusChange,
  size,
  showBadge = true,
  invalidBadgeLabel = INVALID_BADGE_LABEL,
  variant = "both",
}: SectionApprovalActionsProps) => {
  const chips =
    variant === "badge" ? null : (
      <>
        <ActionChip
          active={approvalStatus === "valid"}
          activeBackgroundColor={APPROVAL_VALID_BG}
          activeTextColor={APPROVAL_VALID_TEXT}
          icon={
            <ThumbsUpIcon
              width={14}
              height={14}
              color={
                approvalStatus === "valid" ? APPROVAL_VALID_TEXT : undefined
              }
            />
          }
          label={APPROVE_LABEL}
          size={size}
          onClick={() => onApprovalStatusChange("valid")}
        />
        <ActionChip
          active={approvalStatus === "invalid"}
          activeBackgroundColor={APPROVAL_INVALID_BG}
          activeTextColor={APPROVAL_INVALID_TEXT}
          icon={
            <ThumbsDownIcon
              width={14}
              height={14}
              color={
                approvalStatus === "invalid" ? APPROVAL_INVALID_TEXT : undefined
              }
            />
          }
          label={REJECT_LABEL}
          size={size}
          onClick={() => onApprovalStatusChange("invalid")}
        />
      </>
    );

  const badge =
    variant === "chips" || !showBadge || !approvalStatus ? null : (
      <Tags
        className="authorisation-details__approval-tag"
        label={
          approvalStatus === "valid" ? VALID_BADGE_LABEL : invalidBadgeLabel
        }
        backgroundColor={
          approvalStatus === "valid" ? APPROVAL_VALID_BG : APPROVAL_INVALID_BG
        }
        textColor={
          approvalStatus === "valid"
            ? APPROVAL_VALID_TEXT
            : APPROVAL_INVALID_TEXT
        }
      />
    );

  if (variant === "chips") return <>{chips}</>;
  if (variant === "badge") return <>{badge}</>;
  return (
    <>
      {chips}
      {badge}
    </>
  );
};

export default SectionApprovalActions;
